import styled, { css } from "styled-components";

import {
  COLORS,
  hoverStyles,
  BUTTON_SIZE,
  SMALL_BUTTON_SIZE,
} from "../../../constants/Styles";

const Container = styled.div<{
  isLink: boolean;
  isPrimary: boolean;
  smallSize: boolean;
}>`
  height: ${BUTTON_SIZE};
  width: ${BUTTON_SIZE};
  border-radius: 50%;
  background-color: ${COLORS.darkGray};
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  color: ${COLORS.secondaryLight};

  ${({ smallSize }) =>
    smallSize &&
    `
      height: ${SMALL_BUTTON_SIZE};
      width: ${SMALL_BUTTON_SIZE};
    `}

  ${({ isPrimary }) =>
    isPrimary &&
    `
    background-color: ${COLORS.primary};
    color: ${COLORS.secondary};
  `}

  ${({ isLink, isPrimary }) =>
    isLink &&
    css`
      cursor: pointer;
      ${hoverStyles}
      &:hover {
        background-color: ${isPrimary ? COLORS.altPrimary : COLORS.background};
      }
    `}
`;

const VerticalLine = styled.div<{ isPrimary: boolean }>`
  position: absolute;
  bottom: -1.5rem;
  border-left: 1.5px solid
    ${({ isPrimary }) =>
      isPrimary ? `${COLORS.primary}` : `${COLORS.darkGray}`};
  height: 1.5rem;
`;

export { Container, VerticalLine };
